import React from 'react';
import { SERIF, SANS, IITH } from '@/pages/landing/iithBrand';

/** Branded hero for Roles / Permissions admin pages. */
export default function RbacPageHero({ eyebrow, title, subtitle, actions, children }) {
  return (
    <div
      className="rounded-2xl border overflow-hidden"
      style={{
        background: `linear-gradient(125deg, ${IITH.navy} 0%, ${IITH.navyMid} 52%, #123556 100%)`,
      }}
      data-testid="rbac-page-hero"
    >
      <div className="px-5 py-5 sm:px-6 sm:py-6 flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-[0.22em]" style={{ color: IITH.gold }}>
            {eyebrow}
          </p>
          <h1 className="text-2xl sm:text-3xl font-semibold text-white mt-1" style={{ fontFamily: SERIF }}>
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm mt-1.5 max-w-2xl leading-relaxed" style={{ color: IITH.mute, fontFamily: SANS }}>
              {subtitle}
            </p>
          ) : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}
